import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table-upload-list" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilePdfFilled = _resolveComponent("FilePdfFilled")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_DownloadOutlined = _resolveComponent("DownloadOutlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (f, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: f.uid,
        class: _normalizeClass([_ctx.$style.file, _ctx.$style[f.status]])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.file_content)
        }, [
          _createVNode(_component_FilePdfFilled, {
            class: _normalizeClass(_ctx.$style.preview_icon)
          }, null, 8, ["class"]),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.file_name),
            title: f.name
          }, _toDisplayString(f.name), 11, _hoisted_2),
          (_ctx.showIcon && f.status === 'done')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!['ZIP', 'RAR', 'ETC'].includes(_ctx.extNameList[i]))
                  ? (_openBlock(), _createBlock(_component_EyeOutlined, {
                      key: 0,
                      class: _normalizeClass(_ctx.$style.icon_size),
                      onClick: ($event: any) => (_ctx.handlePreview(f))
                    }, null, 8, ["class", "onClick"]))
                  : _createCommentVNode("", true),
                (i === 0)
                  ? (_openBlock(), _createBlock(_component_DownloadOutlined, {
                      key: 1,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleDownload())),
                      class: _normalizeClass([_ctx.$style.download_icon, _ctx.$style.icon_size])
                    }, null, 8, ["class"]))
                  : (_openBlock(), _createElementBlock("i", {
                      key: 2,
                      class: _normalizeClass([_ctx.$style.i_space])
                    }, null, 2))
              ], 64))
            : _createCommentVNode("", true)
        ], 2)
      ], 2))
    }), 128)),
    (!_ctx.fileList.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}